import { deliveryInfo } from './pricing';
// Landings premium CSE Arbre de Noel + Spectacle Magie - clones du succes /arbre-de-noel-entreprise-brest
export const ARBRE_NOEL_CITIES = {
  quimper: { name: 'Quimper', slug: 'quimper', dept: 'Finistère', code: '29', region: 'FR-29',
    entreprises: 'Cornouaille Agglomération, mairie de Quimper, écoles maternelles, hôpital de Cornouaille, mutuelles et PME quimpéroises',
    salles: 'Pavillon des Expositions, Halles de Cornouaille, salles polyvalentes Ergué-Armel, Penhars, Kerfeunteun',
    concurrents: 'aucun concurrent local majeur — vous êtes LA référence à Quimper',
    delivery: deliveryInfo(0), distance: '0 km' },
  lorient: { name: 'Lorient', slug: 'lorient', dept: 'Morbihan', code: '56', region: 'FR-56',
    entreprises: 'DCNS Naval Group Lorient, Crédit Agricole Morbihan, PME agglomération Lorient, mairies Lanester Hennebont Ploemeur',
    salles: 'Sub Base, Palais des Congrès Lorient, salles Larmor-Plage, Ploemeur, Lanester',
    concurrents: 'quelques agences événementielles à Vannes (moins spécialisées enfants)',
    delivery: deliveryInfo(65), distance: '70 km depuis Quimper' },
  vannes: { name: 'Vannes', slug: 'vannes', dept: 'Morbihan', code: '56', region: 'FR-56',
    entreprises: 'Michelin Vannes, Crédit Mutuel Arkéa, hôpital Chubert, mairies Golfe du Morbihan (Séné, Arradon, Sarzeau)',
    salles: 'Palais des Arts et des Congrès Chorus, salles Séné, Arradon, Theix-Noyalo',
    concurrents: 'agences vannetaises généralistes (peu spécialisées CSE enfants)',
    delivery: deliveryInfo(110), distance: '110 km depuis Quimper' },
  morlaix: { name: 'Morlaix', slug: 'morlaix', dept: 'Finistère', code: '29', region: 'FR-29',
    entreprises: 'Sofradir, Guyader Gastronomie, mairies Baie de Morlaix (Carantec, Roscoff, Saint-Pol-de-Léon)',
    salles: 'Salle du Roudour, Manoir Coat Amour, Château du Taureau, salles Baie de Morlaix',
    concurrents: 'quelques prestataires brestois (75 km) — vous êtes plus proche',
    delivery: deliveryInfo(75), distance: '75 km depuis Quimper' },
};

export const SPECTACLE_MAGIE_CITIES = {
  quimper: { name: 'Quimper', slug: 'quimper', dept: 'Finistère', code: '29', region: 'FR-29',
    contexte: 'écoles quimpéroises (Ergué-Armel, Penhars, Kerfeunteun, Locmaria), MJC, centres de loisirs, mairies',
    events: 'Festival Les Enfants sont des Princes, kermesses écoles, arbres de Noël CSE Cornouaille',
    delivery: deliveryInfo(0) },
  brest: { name: 'Brest', slug: 'brest', dept: 'Finistère', code: '29', region: 'FR-29',
    contexte: 'écoles primaires Brest métropole (Saint-Marc, Lambezellec, Recouvrance), MJC, CE Naval Group, hôpital',
    events: 'kermesses écoles brestoises, arbres de Noël entreprises, Fêtes Maritimes',
    delivery: deliveryInfo(70) },
  lorient: { name: 'Lorient', slug: 'lorient', dept: 'Morbihan', code: '56', region: 'FR-56',
    contexte: 'écoles Lorient agglomération (Lanester, Ploemeur, Hennebont), CE, mairies',
    events: 'kermesses écoles Pays de Lorient, arbres de Noël CSE, Festival Interceltique (animations parallèles)',
    delivery: deliveryInfo(65) },
  concarneau: { name: 'Concarneau', slug: 'concarneau', dept: 'Finistère', code: '29', region: 'FR-29',
    contexte: 'écoles Concarneau-Trégunc-Pont-Aven, MJC, centres de loisirs, mairies',
    events: 'kermesses écoles, Fêtes Bleues de Concarneau, arbres de Noël associations',
    delivery: deliveryInfo(25) },
};
